import { type CSSProperties, useEffect, useMemo } from 'react';
import { Alignment, Fit, Layout, useRive } from 'rive-react';

import notFoundAnimation from './not-found.riv?url';

type NotFoundRiveProps = {
  width?: number | string;
  height?: number | string;
  className?: string;
  fit?: Fit;
  alignment?: Alignment;
  style?: CSSProperties;
};

const NotFoundRive = ({
  width = 320,
  height = 320,
  className,
  fit = Fit.Contain,
  alignment = Alignment.Center,
  style,
}: NotFoundRiveProps) => {
  const layout = useMemo(() => new Layout({ fit, alignment }), [fit, alignment]);

  const { rive, RiveComponent } = useRive({
    src: notFoundAnimation,
    autoplay: true,
    layout,
  });

  useEffect(() => {
    if (!rive) return;

    if (rive.stateMachineNames.length > 0) {
      rive.reset({ stateMachines: rive.stateMachineNames, autoplay: true });
      return;
    }

    if (rive.animationNames.length > 0) {
      rive.reset({ animations: rive.animationNames, autoplay: true });
      return;
    }

    rive.startRendering();
  }, [rive]);

  const canvasStyle = useMemo(
    () => ({
      ...style,
      width,
      height,
    }),
    [height, style, width],
  );

  return <RiveComponent className={className} style={canvasStyle} />;
};

export default NotFoundRive;
